import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SubscriptionPlanRecapComponent } from '~app/app/subscription/components/subscription-plan-recap/subscription-plan-recap.component';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';

@Component({
  selector: 'ads-expenses-creation-dialog',
  standalone: true,
  imports: [],
  templateUrl: './ads-expenses-creation-dialog.component.html',
  styleUrl: './ads-expenses-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdsExpensesCreationDialogComponent extends BaseComponent {
  protected _dialogRef = inject(MatDialogRef<SubscriptionPlanRecapComponent>);
  close(): void {
    this._dialogRef.close();
  }
}
